import { List, Record } from 'immutable';
import { THREAD_REMOVAL_TYPE } from './threadRemovalKeyPaths';
import { HARD_DELETION } from './threadRemovalTypes';
const HardDeletionRemoval = Record({
  [THREAD_REMOVAL_TYPE]: HARD_DELETION,
  audit: null,
  members: List()
}, 'HardDeletionRemoval');
export default HardDeletionRemoval;